"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const colors_1 = __importDefault(require("../../styles/colors"));
const defaultProps = {
    size: 19,
    color: colors_1.default.BLUE,
};
const Icon = ({ color, size, icon }) => (react_1.default.createElement(react_native_fontawesome_1.FontAwesomeIcon, { icon: icon, size: size, color: color }));
Icon.defaultProps = defaultProps;
exports.default = Icon;
